import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
interface PricingCardProps {
  title: string;
  subtitle: string;
  oldPrice: string;
  newPrice: string;
  features: string[];
  isPro?: boolean;
  ctaText: string;
  ctaUrl: string;
  trackValue?: number;
}
export function PricingCard({
  title,
  subtitle,
  oldPrice,
  newPrice,
  features,
  isPro = false,
  ctaText,
  ctaUrl,
  trackValue
}: PricingCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`relative border-2 ${isPro ? 'border-primary' : 'border-gray-800'} rounded-2xl p-8 ${isPro ? 'bg-gradient-to-b from-primary/10 to-transparent' : 'bg-gray-900/50'}`} data-id="element-286">
      {isPro && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-black px-6 py-2 rounded-full font-bold text-sm" data-id="element-287">
          ⭐ MÁS POPULAR
        </div>}

      <div className="text-center mb-6" data-id="element-288">
        <h3 className="text-2xl font-bold mb-2" data-id="element-289">{title}</h3>
        <p className="text-gray-400 text-sm" data-id="element-290">{subtitle}</p>
      </div>

      <div className="text-center mb-8" data-id="element-291">
        <div className="text-gray-500 line-through text-xl mb-2" data-id="element-292">
          {oldPrice}
        </div>
        <div className="text-5xl font-bold text-primary mb-1" data-id="element-293">{newPrice}</div>
        <div className="text-gray-400 text-sm" data-id="element-294">ARS</div>
      </div>

      <ul className="space-y-3 mb-8" data-id="element-295">
        {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-296">
            <CheckIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-297" />
            <span className="text-sm text-gray-300" data-id="element-298">{feature}</span>
          </li>)}
      </ul>

      <a href={ctaUrl} onClick={() => trackInitiateCheckout({
      content_name: title,
      value: trackValue ?? 0
    })} className={`block text-center w-full py-4 rounded-lg font-bold text-lg transition-all ${isPro ? 'bg-primary hover:bg-primary-dark text-black' : 'bg-gray-800 hover:bg-gray-700 text-white'}`} data-id="element-299">
        {ctaText}
      </a>
    </motion.div>;
}